import ExternalCheckout from './ExternalCheckout';

export default ExternalCheckout;
